import { baseAxios, errorHandler } from "../index";

export async function getAllInformasiDebitur(dispatch, data) {
  try {
    const response = await baseAxios.get(
      `webTmp/joinTmpDanPemilikUsaha?page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({ type: "GET_ALL_DATA_IDEB", data: response.data });
    return response.data;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function requestIdebitur(data) {
  try {
    const response = await baseAxios.post("webApiBpd/requestIdebBpd", data, {
      headers: { token: localStorage.getItem("token") },
    });
    return response.data;
  } catch (err) {
    throw err.response.data;
  }
}
